import React from "react";
import styled, { useTheme } from "styled-components";
import Slider from "react-slick";

// layout
import { Flex } from "../../styleguide/layout";

// typograph
import { H3, Span } from "../../styleguide/typography";

// images
import lowTransaction from "../../../assets/low_transaction.png";
import arrowRightTop from "../../../assets/arrow-right-top.png";

const LowTransaction = () => {
  const theme = useTheme();

  const settings = {
    dots: true,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    speed: 500,
    arrows: false,
    adaptiveHeight: true,
    appendDots: dots => <ul>{dots}</ul>,
    customPaging: i => (
      <div className="ft-slick__dots--custom">
        <div className="loading" />
      </div>
    ),
    vertical: "true",
    verticalSwiping: "true",
    draggable: "true",
  };

  return (
    <Flex
      width="100%"
      margin="5rem 0"
      borderRadius="1rem"
      bg={theme.colors.primary}
      minh="544px"
      padding="2.5rem 6rem 0 8.75rem"
      paddingMobile="2.5rem 2.5rem 0 2.5rem"
      minHMobile="460px"
    >
      <Slider style={{ width: "100%" }} {...settings}>
        <div>
          <Flex
            gap="4.5rem"
            position="relative"
            direction="row"
            directionMobile="column"
          >
            <Img src={lowTransaction} alt="low transaction" />

            <Flex
              width="100%"
              direction="column"
              gap="1.4rem"
              margin="7.25rem 0 0 0"
              marginMobile="0"
            >
              <H3 alignMobile="center" width="100%" color={theme.colors.white}>
                <span style={{ color: theme.colors.secondary }}>
                  Low <br />
                </span>{" "}
                Transaction Fees
              </H3>
              <Span
                alignMobile="center"
                maxWidth="430px"
                color={theme.colors.white}
              >
                Why pay 3%-8% when sending money across Africa when you can pay
                only
                <span style={{ color: theme.colors.secondary }}>
                  {" "}
                  0.5% with MULA{" "}
                </span>
                Wallet.
              </Span>
            </Flex>

            <PosImage src={arrowRightTop} alt="arrow" />
          </Flex>
        </div>

        <div>
          <Flex
            gap="4.5rem"
            position="relative"
            direction="row"
            directionMobile="column"
          >
            <Img src={lowTransaction} alt="low transaction" />

            <Flex
              width="100%"
              direction="column"
              gap="1.4rem"
              margin="7.25rem 0 0 0"
              marginMobile="0"
            >
              <H3 alignMobile="center" width="100%" color={theme.colors.white}>
                <span style={{ color: theme.colors.secondary }}>
                  Low <br />
                </span>{" "}
                Transaction Fees
              </H3>
              <Span
                alignMobile="center"
                maxWidth="430px"
                color={theme.colors.white}
              >
                Why pay 3%-8% when sending money across Africa when you can pay
                only
                <span style={{ color: theme.colors.secondary }}>
                  {" "}
                  0.5% with MULA{" "}
                </span>
                Wallet.
              </Span>
            </Flex>

            <PosImage src={arrowRightTop} alt="arrow" />
          </Flex>
        </div>

        <div>
          <Flex
            gap="4.5rem"
            position="relative"
            direction="row"
            directionMobile="column"
          >
            <Img src={lowTransaction} alt="low transaction" />

            <Flex
              width="100%"
              direction="column"
              gap="1.4rem"
              margin="7.25rem 0 0 0"
              marginMobile="0"
            >
              <H3 alignMobile="center" width="100%" color={theme.colors.white}>
                <span style={{ color: theme.colors.secondary }}>
                  Low <br />
                </span>{" "}
                Transaction Fees
              </H3>
              <Span
                alignMobile="center"
                maxWidth="430px"
                color={theme.colors.white}
              >
                Why pay 3%-8% when sending money across Africa when you can pay
                only
                <span style={{ color: theme.colors.secondary }}>
                  {" "}
                  0.5% with MULA{" "}
                </span>
                Wallet.
              </Span>
            </Flex>

            <PosImage src={arrowRightTop} alt="arrow" />
          </Flex>
        </div>

        <div>
          <Flex
            gap="4.5rem"
            position="relative"
            direction="row"
            directionMobile="column"
          >
            <Img src={lowTransaction} alt="low transaction" />

            <Flex
              width="100%"
              direction="column"
              gap="1.4rem"
              margin="7.25rem 0 0 0"
              marginMobile="0"
            >
              <H3 alignMobile="center" width="100%" color={theme.colors.white}>
                <span style={{ color: theme.colors.secondary }}>
                  Low <br />
                </span>{" "}
                Transaction Fees
              </H3>
              <Span
                alignMobile="center"
                maxWidth="430px"
                color={theme.colors.white}
              >
                Why pay 3%-8% when sending money across Africa when you can pay
                only
                <span style={{ color: theme.colors.secondary }}>
                  {" "}
                  0.5% with MULA{" "}
                </span>
                Wallet.
              </Span>
            </Flex>

            <PosImage src={arrowRightTop} alt="arrow" />
          </Flex>
        </div>
      </Slider>
    </Flex>
  );
};

export default LowTransaction;

export const Img = styled.img`
  width: 28rem;
  height: auto;

  @media (max-width: 768px) {
    order: 2;
    width: 100%;
  }
`;

const PosImage = styled.img`
  position: absolute;
  bottom: 5rem;
  left: 30rem;
  width: 8rem;
  height: auto;

  @media (max-width: 768px) {
    display: none;
  }
`;
